document.addEventListener('alpine:init', () => {
  Alpine.data('integrationsIndex', () => ({
    searchQuery: '',
    allIntegrations: [],
    showBetaModal: false,
    showAppleVideoAccessModal: false,
    showProUpgradeModal: false,
    showSalesforceSupportModal: false,
    showRemoveModal: false,
    removeIntegrationType: null,
    removeUrl: null,
    removeLoading: false,
    
    init() {
      // Get integrations data from the template ref
      const integrationsData = this.$refs.integrations_data?.dataset?.integrations;
      
      if (!integrationsData) {
        console.error('Integrations data not found. Ensure the template includes a ref="integrations_data" element with data-integrations attribute.');
        this.allIntegrations = [];
        return;
      }
      
      try {
        this.allIntegrations = JSON.parse(integrationsData);
      } catch (error) {
        console.error('Failed to parse integrations data:', error);
        this.allIntegrations = [];
      }
    },
    
    openBetaModal() {
      this.showBetaModal = true;
    },
    
    closeBetaModal() {
      this.showBetaModal = false;
    },

    openAppleVideoAccessModal() {
      this.showAppleVideoAccessModal = true;
    },

    closeAppleVideoAccessModal() {
      this.showAppleVideoAccessModal = false;
    },
    
    openProUpgradeModal() {
      this.showProUpgradeModal = true;
    },
    
    closeProUpgradeModal() {
      this.showProUpgradeModal = false;
    },

    openSalesforceSupportModal() {
      this.showSalesforceSupportModal = true;
    },

    closeSalesforceSupportModal() {
      this.showSalesforceSupportModal = false;
    },
    
    openRemoveModal(type, url = null) {
      this.removeIntegrationType = type;
      this.removeUrl = url;
      this.showRemoveModal = true;
    },
    
    closeRemoveModal() {
      if (this.removeLoading) return;

      this.showRemoveModal = false;
      this.removeIntegrationType = null;
      this.removeUrl = null;
      this.removeLoading = false;
    },
    
    async confirmRemove() {
      if (!this.removeIntegrationType) return;
      
      this.removeLoading = true;
      
      try {
        // Get the show ID from the URL
        const pathParts = window.location.pathname.split('/');
        const showsIndex = pathParts.indexOf('shows');
        const showId = showsIndex !== -1 ? pathParts[showsIndex + 1] : null;
        
        if (!showId) {
          console.error('Could not find show ID');
          this.removeLoading = false;
          return;
        }
        
        const fallbackUrl = `/shows/${showId}/integrations/${this.removeIntegrationType}/disconnect`;
        const response = await fetch(this.removeUrl || fallbackUrl, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
          }
        });
        
        const data = await response.json();
        
        if (data.success) {
          if (data.redirect_url) {
            window.location.assign(data.redirect_url);
          } else {
            window.location.reload();
          }
        } else {
          alert(data.error || 'Failed to remove integration');
          this.removeLoading = false;
        }
      } catch (error) {
        console.error('Error removing integration:', error);
        alert('An unexpected error occurred');
        this.removeLoading = false;
      }
    },
    
    get filteredIntegrations() {
      const query = this.searchQuery.toLowerCase().trim();
      if (query === '') {
        return this.allIntegrations;
      }
      return this.allIntegrations.filter(integration => 
        integration.name.toLowerCase().includes(query)
      );
    }
  }))
})
